export enum ParentResources {
    AcademyGuide = 201,
    ZoouGuide = 202,
    SsgrinGuide = 203,
    HohGuide = 204,
    SimGuide = 205,
};
